export default "__VITE_PUBLIC_ASSET__e9e6f72f__"